import { matchQuery, MutationCache, QueryClient } from '@tanstack/react-query';
import { HOUR_IN_MS } from '@/constants/date.constants';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 24 * HOUR_IN_MS, // TEMPORARY! Will be fixed within caching strategy updates
    },
  },
  mutationCache: new MutationCache({
    onSuccess: async (_data, _variables, _context, mutation) => {
      if (mutation.meta?.invalidates?.length) {
        queryClient
          .invalidateQueries({
            predicate: (query) =>
              mutation.meta?.invalidates?.some((queryKey) => matchQuery({ queryKey }, query)) ?? false,
          })
          .then(() => {});
      }

      if (mutation.meta?.refetch?.length) {
        await queryClient.refetchQueries({
          predicate: (query) => mutation.meta?.refetch?.some((queryKey) => matchQuery({ queryKey }, query)) ?? false,
        });
      }
    },
  }),
});
